export default __webpack_public_path__ + "static/media/dozule7.902aaf53.jpg";